module.exports = __webpack_public_path__ + "static/media/bg_1.2c5b0dca.jpg";